import { useEffect, useRef, useState } from "react";
import { Col, Form, Dropdown, DropdownButton } from "react-bootstrap";
import Tooltip from "./Tooltip";

// Set default values to specific props to avoid errors. Set default class 'class-placeholder' to avoid 'className cannot be empty' error

const SelectCol = ({
  options,
  label,
  value,
  name,
  handleChange,
  colClass = "class-placeholder",
  disabled = false,
  defaultVal = null,
  isFullWidth = false,

  hint = "",
}) => {
  const [allOptions, setAllOptions] = useState([]);

  // Check if there is a default option and add it to all options
  useEffect(() => {
    let tempOptions = [];
    if (defaultVal === null) tempOptions = [...options];
    else tempOptions = [defaultVal, ...options];
    const initialVal = value.length === 0 ? tempOptions[0] : value;

    onChange(initialVal);
    setAllOptions(tempOptions);
  }, []);

  const onChange = e => {
    // Event simulator object. Since this is custom select we cannot use event.target on it
    const event = { target: { name: name, value: e } };
    handleChange(event);
  };

  return (
    <Form.Group
      as={Col}
      sm={12}
      lg={isFullWidth ? 12 : 6}
      className={`mb-3 ${colClass}`}
    >
      <Form.Label htmlFor={label.toLowerCase()} className="d-flex ">
        <small>{label} </small>
        {hint && <Tooltip text={hint} />}
      </Form.Label>
      <DropdownButton
        className="form-dropdown"
        id={label.toLowerCase()}
        name={name}
        value={value}
        onSelect={onChange}
        disabled={disabled}
        title={value}
        variant="custom"
      >
        {allOptions.map((option, i) => (
          <Dropdown.Item className="p-3" eventKey={option} key={i}>
            {option}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </Form.Group>
  );
};

export default SelectCol;
